import Plyr from 'plyr';

import { scaleBlockToScreen } from '../helpers/video-helpers';
import scrollTo from '../helpers/scrollTo';

import { CLASSES } from '../helpers/consts';

export default () => {
	const videoWrapper = document.querySelector('.js-hero-media-wrapper');
	const videoBlock = document.querySelector('.js-hero-media-block');
	const video = document.querySelector('.js-hero-media');

	if(!video || !videoBlock) return;

	const position = videoBlock.dataset.position || false

	const player = new Plyr(video, {
		ratio: '16:9',
		muted: true,
		autoplay: true,
		controls: false,
		// speed: {
		// 	selected: 10
		// },
		// loop: isAboutPage ? true : false
		vimeo: {
			loop: true,
			background: true,
			transparency: true,
			// autoplay: true,
			muted: true,
			playsinline: true
		}
	});
	player.on('ready', event => {
		player.muted = true;
		player.play();
		setTimeout(() => {
			videoBlock.classList.add(CLASSES.active);
		}, 400);
	});

	let isPlayonEnd = true;
	let canScrollDown = true;

	const observer = new IntersectionObserver((entries) => {
		entries.forEach((entry) => {
			if(entry.isIntersecting) {
				// isPlayonEnd = true;
				// player.restart();
				player.stop();
				setTimeout(() => {
					player.play();
				}, 150);
			}
			else {
				// isPlayonEnd = false;
				canScrollDown = false;
				player.stop();
			}
		});
	}, { threshold: 0 });
	observer.observe(videoBlock);


	player.on('ended', function() {

		// if(isAboutPage) {
			console.log('restart')
			// player.restart();
			player.stop();
			setTimeout(() => {
				player.play();
			}, 150);

			if(!canScrollDown) return;
			canScrollDown = false;
			const videoBlockH = videoWrapper.offsetHeight;

			scrollTo(0, videoBlockH);
	});



	if (position){
		console.log('postion set', position)
		scaleBlockToScreen(videoBlock, position);
	}else{
		scaleBlockToScreen(videoBlock);
	}

};
